import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Input } from '../../components/forms/Input';

export function ValidationCode() {
  return (
    <>
      <div className="container">
        <div className="my-3">
          <div className="container">
            <Card>
              <p className="fs-3">Bem vindo ao Game of Influencers!</p>
              <p>
                Enviamos um código no seu e-mail para validar o seu cadastro.
              </p>
              <form>
                <div className="mb-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Código enviado no e-mail
                  </label>
                  <Input
                    name="code"
                    type="text"
                    placeholder="Digite seu código aqui"
                  />
                  <div className="my-3">
                    <Button text="Validar" icon="check" color="primary" />
                  </div>
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
